import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const VendorOrderViewModule = new Module({
  id: 'VENDOR_ORDERS:VIEW:*',
  name: 'Purchase',
  label: 'Purchase Order',
  path: 'purchase-orders',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/VendorOrders/View'))
  ),
  actions: {
    vendorOrderDetails: {
      id: 'VENDOR_ORDERS:VIEW:DETAILS',
      name: 'purchase-order-details',
      label: 'Purchase Order Details'
    },
    markInProgress: {
      id: 'VENDOR_ORDERS:VIEW:MARK_IN_PROGRESS',
      name: 'markInProgress',
      label: 'Mark as In Progress'
    },
    scanMaterial: {
      id: 'VENDOR_ORDERS:VIEW:SCAN_MATERIAL',
      name: 'scanMaterial',
      label: 'Scan Material'
    },
    downloadSheet: {
      id: 'VENDOR_ORDERS:VIEW:DOWNLOAD-SHEET',
      name: 'download-sheet',
      label: 'Download Sheet'
    },
    // editFirmwareInOrder: {
    //   id: 'VENDOR_ORDERS:VIEW:EDIT-FIRMWARE-IN-ORDER',
    //   name: 'edit-firmware-in-order',
    //   label: 'Edit Firmware'
    // },
    cancelOrder: {
      id: 'VENDOR_ORDERS:VIEW:CANCEL-ORDER',
      name: 'cancel-order',
      label: 'Cancel Order'
    }
  }
});

export const VendorOrderDetailsModule = new Module({
  id: 'VENDOR_ORDERS:VIEW:DETAILS',
  name: 'purchaseOrderDetails',
  path: 'purchase-orders/details',
  pathDef: 'purchase-orders/details/:orderId',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/VendorOrders/Form'))
  )
});

export const AddVendorOrderModule = new Module({
  id: 'VENDOR_ORDERS:VIEW:ADD_ORDER',
  name: 'addvendororder',
  path: 'purchase-orders/add',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/VendorOrders/ADD'))
  ),
  actions: {
    addOrder: {
      id: 'VENDOR_ORDERS:ACTION:ADD_ORDER',
      name: 'addvendororder',
      label: 'Add Vendor Order'
    }
  }
});

const VendorOrderModules = [
  VendorOrderViewModule,
  VendorOrderDetailsModule,
  AddVendorOrderModule
];

export default new ModuleBundle('VendorOrder', VendorOrderModules);
